import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isAndroid, isIOS, isBrowser } from "react-device-detect";
import logo from '../assets/logo-icon.png';
import app_store_logo from '../assets/AppStore.svg';
import google_play_logo from '../assets/google-play.png';
import '../css/SignIn.css';

import { UserActions, ConsultationsActions, NavigationActions } from '../actions';
import { SignIn, Button } from  '../components'

class StripeRedirectScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  componentDidMount() {

  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align sign-in-page">
        <div className="flex-container-column basic-container" style={{ justifyContent: 'center', alignItems: 'center', backgroundColor: 'white' }}>
          <img className="sign-in-logo-image" src={logo} alt="Icon Text" />
          <span style={{ marginTop: 2, fontSize: 24, fontWeight: '600', color: '#404040' }}>TeleTails</span>

          <span style={{ marginTop: 10, fontSize: 14, color: 'grey' }}>Thank You</span>
          <span style={{ fontSize: 14, color: 'grey' }}>Validation information submitted.</span>
          <span style={{ marginTop: 10, fontSize: 14, color: 'grey' }}>You can close this window to return to your TeleTails account.</span>

          { /* <Button value='Close Window' onClick={ () => {
            window.close()
          }} />  */ }

        </div>
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {

  }
}

const mapDispatchToProps = (dispatch) => {
  return {

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StripeRedirectScreen)
